import type { FeatureFlags } from '@noths/polaris-client-feature-flags';
import type { DeliveryZoneCode } from '@noths/polaris-client-localisation';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';
import { createSlice } from '@reduxjs/toolkit';

export type CookieConsent = {
  analyticalExperienceCookiesConsented?: boolean;
  functionalCookiesConsented?: boolean;
  performanceCookiesConsented?: boolean;
  targetingAdvertisingCookiesConsented?: boolean;
  technicalCookiesConsented?: boolean;
};

export interface UserState {
  bot: boolean;
  cookieConsent?: CookieConsent;
  countryCode: string;
  currencyCode: CurrencyCode;
  deliveryZone?: DeliveryZoneCode;
  featureFlags?: FeatureFlags;
  gaVisitorId?: string;
}

export const initialState: Readonly<UserState> = {
  bot: false,
  countryCode: 'GB',
  currencyCode: 'GBP',
};

export const { actions, name, reducer } = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCookieConsent: (state, { payload }) => {
      if (payload) {
        state.cookieConsent = payload;
      }
    },
    setDeliveryZone: (state, { payload }) => {
      if (payload) {
        state.deliveryZone = payload;
      }
    },
    setFeatureFlags: (state, { payload }) => {
      if (payload) {
        state.featureFlags = payload;
      }
    },
  },
});
